import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import SwiperButtonRounded from "@components/button/SwiperButtonRounded";
import MobileSwiper from "@components/swiper/MobileSwiper";
import WidgetWrapper from "@components/wrapper/WidgetWrapper";
import TrendingTopicsCarouselWidgetSlide from "@components/trendingTopics/TrendingTopicsCarouselWidgetSlide";
import cn from "classnames";
import useIsRTL from "@hooks/useIsRTL";
const TrendingTopicsCarouselWidget = ({ items, bottomMargin, topMargin, widgetID, title, description }) => {
    const [swiper, setSwiper] = useState();
    const [enableEvents, setEnableEvents] = useState(false);
    const [activeSlideIndex, setActiveSlideIndex] = useState(0);
    const { isRtl } = useIsRTL();
    const prevBtnDisabled = activeSlideIndex === 0;
    const nextBtnDisabled = items && activeSlideIndex === items.length - 1;
    const btnDisabledClassName = "swiper-btn__rounded--disabled";
    const showControlBtns = items && items.length > 1;
    useEffect(() => {
        setTimeout(() => {
            setEnableEvents(true);
        }, 500);
    }, []);
    return (_jsxs(WidgetWrapper, { className: "trending-topics-carousel", bottomMargin: bottomMargin, topMargin: topMargin, id: widgetID, children: [title && _jsx("h3", { className: "trending-topics-carousel__title", children: title }), description && _jsx("p", { className: "trending-topics-carousel__sub-title", children: description }), _jsxs("div", { className: cn("flex items-center", !enableEvents && "pointer-events-none"), children: [showControlBtns && _jsx(SwiperButtonRounded, { isNext: isRtl, swiper: swiper, className: cn("opacity-0", prevBtnDisabled && btnDisabledClassName) }), _jsx(MobileSwiper, { className: "infinity-swiper", data: items, setSwiper: setSwiper, displayData: (trendingTopic) => _jsx(TrendingTopicsCarouselWidgetSlide, { ...trendingTopic }), autoplay: false, pagination: { clickable: true }, breakpoints: {
                            320: {
                                slidesPerView: "auto",
                                spaceBetween: 16,
                                centeredSlides: true
                            },
                            976: {
                                slidesPerView: 1,
                                spaceBetween: 500,
                                centeredSlides: false
                            }
                        }, onSlideChange: (updatedSwiper) => setActiveSlideIndex(updatedSwiper.activeIndex) }), showControlBtns && _jsx(SwiperButtonRounded, { isNext: !isRtl, swiper: swiper, className: cn("opacity-0", nextBtnDisabled && btnDisabledClassName) })] })] }));
};
export default TrendingTopicsCarouselWidget;
